import { Link } from 'react-router-dom';
import { BUSINESS_INFO } from '../../mocks/lisaMerkleData';

interface MidPageCTAProps {
  heading?: string;
  subtext?: string;
  ctaText?: string;
  ctaLink?: string;
  bgColor?: 'cream' | 'charcoal' | 'warm';
}

export default function MidPageCTA({
  heading = 'Schedule a Private Design Consultation',
  subtext = 'Serving Beverly Hills, Los Angeles, and discerning clients nationwide.',
  ctaText = 'Request a Consultation',
  ctaLink = '/location#contact',
  bgColor = 'charcoal',
}: MidPageCTAProps) {
  const bg = bgColor === 'charcoal'
    ? 'bg-charcoal'
    : bgColor === 'warm'
    ? 'bg-cream-warm'
    : 'bg-cream';

  const isLight = bgColor === 'cream' || bgColor === 'warm';

  return (
    <section className={`${bg} py-14`}>
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className={`hidden sm:block w-px h-12 ${isLight ? 'bg-stone/40' : 'bg-stone/30'}`} />
            <div>
              <h2 className={`font-display text-2xl md:text-3xl font-light leading-tight ${isLight ? 'text-charcoal' : 'text-cream'}`}>
                {heading}
              </h2>
              <p className={`text-sm font-sans mt-1.5 ${isLight ? 'text-charcoal/50' : 'text-cream/50'}`}>
                {subtext}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-4 flex-shrink-0">
            <Link
              to={ctaLink}
              className={`px-8 py-3.5 text-[10px] tracking-[0.2em] uppercase font-medium font-sans rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                isLight
                  ? 'bg-charcoal text-cream hover:bg-charcoal/80'
                  : 'bg-cream text-charcoal hover:bg-white'
              }`}
            >
              {ctaText}
            </Link>
            <a
              href={BUSINESS_INFO.phoneHref}
              className={`flex items-center gap-2 px-8 py-3.5 border text-[10px] tracking-[0.2em] uppercase font-medium font-sans rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                isLight
                  ? 'border-charcoal/20 text-charcoal hover:bg-charcoal/5'
                  : 'border-cream/20 text-cream hover:bg-cream/10'
              }`}
            >
              <i className={`ri-phone-line text-sm ${isLight ? 'text-stone-dark' : 'text-stone'}`} />
              {BUSINESS_INFO.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
